import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Form, InputGroup, Button } from "react-bootstrap";
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import * as Admin from "../../../store/ducks/admin.duck";
import * as Reference from "../../../store/ducks/reference.duck";
import { Grid, Paper, MenuItem, FormControl, Select, InputLabel, makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: "1rem", // Make the text bigger
    padding: "12px 16px", // Add more padding
    maxWidth: 300, // Optional: widen the tooltip
  },
}))(Tooltip);

export default function SearchClientData(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const filters = useSelector((state) => state.admin.Filters);
  const searchResults = useSelector((state) => state.admin.SearchResults);
  const searchStatus = useSelector((state) => state.admin.SearchStatus);
  const areasOfInterestReference = useSelector((state) => state.reference.AreasOfInterest);
  useEffect(() => {
    dispatch(Reference.actions.fetchAreasOfInterest({ providerType: "Psychologist", centralisedservice: false }));
  }, [dispatch]);

  const searchSearchResults = (searchResult) => {
    if (searchResult.aoi && searchResult.aoi.length > 0) {
      var aoiArray = searchResult.aoi.split(",");
    } else {
      var aoiArray = null;
    }
    //
    if (
      true &&
      (!filters.searchClientWithinData ||
        filters.searchClientWithinData.length === 0 ||
        (searchResult.searchString.length > 0 &&
          searchResult.searchString.match(/^[a-zA-Z0-9&@ ]*$/) !== null &&
          filters.searchClientWithinData.split(" ").every((word) => searchResult.searchString.toLowerCase().search(word.toLowerCase()) !== -1))) &&
      (!filters.searchClientDataType ||
        filters.searchClientDataType === "All" ||
        (filters.searchClientDataType && searchResult.entity === filters.searchClientDataType)) &&
      (!filters.searchClientDataStatus ||
        filters.searchClientDataStatus === "All" ||
        (filters.searchClientDataStatus && searchResult.status === filters.searchClientDataStatus)) &&
      (filters.clientsAOI === "All" || (aoiArray && aoiArray.length > 0 && aoiArray.some((issue) => issue === filters.clientsAOI)))
    ) {
      return searchResult;
    }
  };

  const filteredSearchResults = searchResults.filter((searchResult) => searchSearchResults(searchResult));

  const linkPage = (uri, id, entity) => {
    //
    if (entity === "Clients") {
      dispatch(Admin.actions.setFilters({ filterName: "clientsListLoadClientID", filterValue: id }));
      props.history.push(uri);
    }
    if (entity === "ClientInvites") {
      // Client Invites are an issue as the default display only displays the last month so a random call to particular id will lead to problems thus the creation date is stored in the URL
      // console.log(uri)
      // console.log(new Date(uri))
      dispatch(Admin.actions.initialiseInvites());
      dispatch(Admin.actions.setFilters({ filterName: "clientInviteStartDate", filterValue: new Date(uri) }));
      dispatch(Admin.actions.setFilters({ filterName: "invitesListLoadInviteID", filterValue: id }));
      props.history.push("clientinvites");
    }
    // Note don't redirect to a particular id in faxes as faxes are not an entity (i.e. modal)
    if (entity === "Faxes") {
      props.history.push("faxes");
    }
  };

  function SearchData() {
    // call Search API which will then call the filter value to use as the search
    dispatch(Admin.actions.searchClientData());
  }

  const columns = [
    { field: "id", headerName: "ID", width: 100, hide: true },
    { field: "clientName", headerName: "Name", width: 200 },
    { field: "searchString", headerName: "Matching Field", width: 300 },
    {
      field: "createdon",
      type: "date",
      headerName: "Created On",
      width: 155,
      sortable: true,
      renderCell: (params) => (params.row.createdon != null ? format(new Date(params.row.createdon), "dd-MM-yyyy HH:mm") : null),
    },
    { field: "entity", headerName: "Area", width: 120 },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      cellClassName: (params) => (params.row.status && params.row.status === "Archived" ? "flag-archive-cell" : "flag-empty-cell"),
    },
    { field: "nextBookingID", headerName: "Next Booking ID", width: 120, hide: true },
    {
      field: "topBookingClient",
      type: "date",
      headerName: "Booking (Client)",
      width: 175,
      sortable: true,
      cellClassName: (params) => (params.row.nextBookingID !== null ? "future-booking" : "grid-mono-font"),
      renderCell: (params) => (
        <>
          {params.row.nextBookingID ? (
            <div className="cell-Link">{format(new Date(params.row.topBookingClient), "dd-MM-yyyy HH:mm")}</div>
          ) : params.row.topBookingClient != null ? (
            format(new Date(params.row.topBookingClient), "dd-MM-yyyy HH:mm")
          ) : null}
        </>
      ),
    },
    {
      field: "uri",
      headerName: "Link",
      width: 120,
      renderCell: (params) => (
        <strong>
          <div onClick={() => linkPage(params.row.uri, params.row.id, params.row.entity)} className="cell-Link">
            View
          </div>
        </strong>
      ),
    },
  ];

  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <h4 style={{ marginBottom: 12 }}>Global Client Data Search</h4>
        </Grid>
      </Grid>

      <Paper>
        <Grid container style={{ padding: 10 }}>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <CustomTooltip title="Search Date of Birth using the format of YYYYMMDD">
                <Form.Control
                  type="text"
                  value={filters.searchClientData}
                  onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: "searchClientData", filterValue: event.target.value }))}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" && filters.searchClientData.length > 2) {
                      SearchData();
                    }
                  }}
                  autoComplete="OFF"
                  style={{ maxWidth: 250, height: 35, backgroundColor: filters.clientsTerm.length > 0 ? "rgb(250 239 195)" : "white" }}
                />
              </CustomTooltip>
              <InputGroup.Append onClick={() => dispatch(Admin.actions.setFilters({ filterName: "searchClientData", filterValue: "" }))}>
                <InputGroup.Text>
                  <ClearIcon fontSize="small" style={{ color: filters.clientsTerm.length > 0 ? "#222222" : "silver", marginLeft: -3 }} />
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Grid>
          <Grid item style={{ marginLeft: 20, marginRight: 10 }}>
            <Button
              variant="primary"
              size="sm"
              onClick={() => SearchData()}
              disabled={filters.searchClientData.length > 2 ? false : true}
              style={{ height: 35, minWidth: 80 }}
            >
              Search
            </Button>
          </Grid>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text
                  style={{
                    width: 140,
                    textAlign: "center",
                    color: searchResults && searchResults.length > 0 ? "white" : "black",
                    backgroundColor: searchResults && searchResults.length > 0 ? "blue" : "dark grey",
                    fontSize: 12,
                    fontStyle: "bold",
                  }}
                >
                  Search Within
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                value={filters.searchClientWithinData}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: "searchClientWithinData", filterValue: event.target.value }))}
                autoComplete="OFF"
                style={{ marginLeft: 80, maxWidth: 250, height: 35, backgroundColor: filters.clientsTerm.length > 0 ? "rgb(250 239 195)" : "white" }}
              />
              <InputGroup.Append onClick={() => dispatch(Admin.actions.setFilters({ filterName: "searchClientWithinData", filterValue: "" }))}>
                <InputGroup.Text>
                  <ClearIcon fontSize="small" style={{ color: filters.clientsTerm.length > 0 ? "#222222" : "silver", marginLeft: -3 }} />
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Grid>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="clientsType-label" className={classes.label}>
                Area
              </InputLabel>
              <Select
                labelId="clientsType-label"
                id="searchClientDataType"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                value={filters.searchClientDataType}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: "searchClientDataType", filterValue: event.target.value }))}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Clients">Clients</MenuItem>
                <MenuItem value="ClientInvites">Client Invites</MenuItem>
                <MenuItem value="Faxes">Faxes</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="clientsStatus-label" className={classes.label}>
                Status
              </InputLabel>
              <Select
                labelId="clientsStatus-label"
                id="searchClientDataType"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                value={filters.searchClientDataStatus}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: "searchClientDataStatus", filterValue: event.target.value }))}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Registered">Registered</MenuItem>
                <MenuItem value="Saved">Saved</MenuItem>
                <MenuItem value="Sent">Sent</MenuItem>
                <MenuItem value="Reminder">Reminder</MenuItem>
                <MenuItem value="Ready to Archive">Ready to Archive</MenuItem>
                <MenuItem value="Call">Call</MenuItem>
                <MenuItem value="Hold">Hold</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
                <MenuItem value="Archived">Archived</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="clientsAOI-label" className={classes.label}>
                Area of Interest
              </InputLabel>
              <Select
                labelId="clientsAOI-label"
                id="clientsAOI"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                value={filters.clientsAOI}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: "clientsAOI", filterValue: event.target.value }))}
              >
                <MenuItem value="All">All</MenuItem>
                {areasOfInterestReference.map((row) => {
                  return (
                    <MenuItem key={`key-${row.id}`} value={row.id}>
                      {row.issue}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      <Paper style={{ height: 700 }}>
        <DataGridPro
          rows={filteredSearchResults}
          columns={columns}
          checkboxSelection={false}
          rowHeight={40}
          sortModel={[{ field: "createdon", sort: "desc" }]}
          localeText={{
            noRowsLabel: searchStatus === "NoResults" ? "No rows found" : "Enter search criteria and click Search",
          }}
        />
      </Paper>
    </>
  );
}
